import { render, staticRenderFns } from "./printradiologyreport.vue?vue&type=template&id=52603682&"
import script from "./printradiologyreport.vue?vue&type=script&lang=js&"
export * from "./printradiologyreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports